import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Boxes, Menu, X } from "lucide-react";

const LINKS = [
  { label: "Why SmartContainer", href: "#why" },
  { label: "How It Works", href: "#how" },
  { label: "Builder", href: "#builder" },
  { label: "Workspace", href: "#workspace" },
  { label: "FAQ", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -24, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "dm-glass border-b border-slate-200/70" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="dm-container flex items-center justify-between h-16">
        <a href="#top" className="flex items-center gap-2.5" data-testid="brand-logo">
          <span className="grid place-items-center h-8 w-8 rounded-lg bg-slate-900">
            <Boxes className="h-4 w-4 text-white" strokeWidth={2} />
          </span>
          <span className="flex items-baseline gap-1.5">
            <span className="text-[15px] font-bold tracking-tight text-slate-900">DeMaxtore</span>
            <span className="hidden sm:inline text-[11px] font-medium text-slate-400 border-l border-slate-200 pl-1.5">SmartContainer™</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href}
              className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
              data-testid={`nav-${l.href.slice(1)}`}>
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <button className="text-sm font-semibold text-slate-700 hover:text-slate-900 transition-colors" data-testid="nav-signin">Sign in</button>
          <button className="dm-btn-primary py-2.5" data-testid="nav-cta">Create Free Workspace</button>
        </div>

        <button className="lg:hidden grid place-items-center h-9 w-9 rounded-lg border border-slate-200"
          onClick={() => setOpen((v) => !v)} data-testid="mobile-menu-toggle" aria-label="Toggle menu">
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden dm-glass border-t border-slate-200/70 px-5 py-4 space-y-3" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="block text-sm font-medium text-slate-700">{l.label}</a>
          ))}
          <button className="dm-btn-primary w-full mt-2">Create Free Workspace</button>
        </div>
      )}
    </motion.header>
  );
}
